import { render, staticRenderFns } from "./CategoriesFilterMobile.vue?vue&type=template&id=1c08e8fa&scoped=true&"
import script from "./CategoriesFilterMobile.vue?vue&type=script&lang=js&"
export * from "./CategoriesFilterMobile.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesFilterMobile.vue?vue&type=style&index=0&id=1c08e8fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08e8fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c08e8fa')) {
      api.createRecord('1c08e8fa', component.options)
    } else {
      api.reload('1c08e8fa', component.options)
    }
    module.hot.accept("./CategoriesFilterMobile.vue?vue&type=template&id=1c08e8fa&scoped=true&", function () {
      api.rerender('1c08e8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/MobileFilters/CategoriesFilterMobile.vue"
export default component.exports